export default function NavigationLoading() {
	return null;
}
